import { IDeleteClienteCentroCustoUseCase } from "../../../presentation/useCases/delete/delete_cliente_centro_custo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteClienteCentroCustoUseCase
 */

export class DeleteClienteCentroCustoUseCase implements IDeleteClienteCentroCustoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idClienteCentroCusto: number): Promise<void> {
    return this.repository.deleteClienteCentroCustoById(idClienteCentroCusto);

  }
}
